export const INITIAL_ROUTE = {
  OFFER: "/offer/available-offers",
  HOME: "/",
  LOYALTY_DETAILS: "/loyalty-info",
  TRANSACTION_HISTORY: "/transaction-history",
  REFER_A_FRIEND: "/refer-friend/pwa",
  TERMS_AND_CONDITIONS:"/terms-and-conditions",
  TICKET_DESK:"/tickets",
  SCHEME_MANAGEMENT:"/scheme"
};
